import HandleClient, { IHandle } from "@koralabs/adahandle-sdk";
import { IPersonalizationDesigner } from "@koralabs/handles-public-api-interfaces";
import { UseQueryResult, useQuery } from "@tanstack/react-query";
import { useHandleClient } from "../../hooks/useHandleClient";

export const useHandleData = (handle: string): UseQueryResult<IHandle> => {
  const handleClient = useHandleClient();

  return useQuery(
    ["handleData", handle],
    async () => {
      if (handleClient && handle) {
        if (HandleClient.isCIP68({ value: handle })) {
          const handleData = await handleClient.provider().getAllData({ value: handle });

          return {
            ...handleData,
            cipType: "cip68",
          };
        }
      }

      return {};
    },
    {
      refetchOnWindowFocus: false,
      cacheTime: 1000 * 60, // 1 Minute
      refetchInterval: 1000 * 60, // 1 Minute
      staleTime: 1000 * 60, // 1 Minute
    }
  );
};

export const usePersonalizedHandleData = (
  handle: string
): UseQueryResult<IPersonalizationDesigner> => {
  const handleClient = useHandleClient();

  return useQuery(
    ["personalizedHandleData", handle],
    async () => {
      if (handleClient && handle) {
        if (HandleClient.isCIP68({ value: handle })) {
          const handleData = await handleClient.provider().getPersonalizedData({ value: handle });

          return {
            ...handleData?.designer,
            cipType: "cip68",
          };
        }
      }

      return {};
    },
    {
      refetchOnWindowFocus: false,
      cacheTime: 1000 * 60, // 1 Minute
      refetchInterval: 1000 * 60, // 1 Minute
      staleTime: 1000 * 60, // 1 Minute
    }
  );
};
